import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "./OurServices";
import "../../styles/home.css";

const n = SERVICES.length;
const pad = (i) => String(i + 1).padStart(2, "0");

// A 3D prism that turns through the four services, with the services listed
// under it. Hovering a service turns the prism to it; clicking one (or the
// prism) calls onOpen with its index. Used by both What We Do sections.
const ServicePrism = ({ onOpen, className = "", style }) => {
  // The prism only turns forward: `turn` keeps counting, the face shown is turn % n.
  const [turn, setTurn] = useState(0);
  const [paused, setPaused] = useState(false);
  const active = turn % n;

  useEffect(() => {
    if (paused) return undefined;
    const timer = setTimeout(() => setTurn((t) => t + 1), 2600);
    return () => clearTimeout(timer);
  }, [turn, paused]);

  const turnTo = (i) => setTurn((t) => t + ((i - (t % n) + n) % n));

  return (
    <div
      className={`wwd-showcase ${className}`}
      style={style}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="wwd-stage" onClick={() => onOpen(active)} aria-hidden="true">
        <div className="wwd-prism" style={{ "--turn": turn }}>
          {SERVICES.map((s, i) => (
            <div className={`wwd-face${i === active ? " is-front" : ""}`} style={{ "--i": i }} key={s.title}>
              <span className="wwd-face-index">{pad(i)} / {pad(n - 1)}</span>
              <strong>{s.title}</strong>
              <span className="wwd-face-desc">{s.desc}</span>
            </div>
          ))}
        </div>
      </div>

      <ul className="wwd-list">
        {SERVICES.map((s, i) => (
          <li key={s.title}>
            <button
              type="button"
              className={i === active ? "is-active" : ""}
              onMouseEnter={() => turnTo(i)}
              onFocus={() => turnTo(i)}
              onClick={() => onOpen(i)}
            >
              <span>{pad(i)}</span>
              {s.title}
              <ArrowRight size={16} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServicePrism;
